import { SelectInputV2 } from '@frontend/components/basic-forms';
import { ActionModal } from '@frontend/components/modal';
import { ToastUtil } from '@frontend/toast-utils';
import { TransactionWorkflowClient } from '@frontend/transaction/api';
import { TransactionTriggerName } from '@frontend/transaction/types';
import { FormattedMessage, useIntl } from 'react-intl';

import { ChangeTransactionStateModalProps, useChangeTransactionStateModal } from './change-transaction-state-modal.controller';

export const ChangeTransactionStateModal = (props: ChangeTransactionStateModalProps) => {
    const intl = useIntl();
    const viewProps = useChangeTransactionStateModal(props);

    return (
        <ActionModal
            title={
                <FormattedMessage
                    id='action-modal.change-transaction-state'
                    defaultMessage='Change transaction status'
                />
            }
            cancel={{
                onCancel: () => viewProps.closeTopModal(),
                label: (
                    <FormattedMessage
                        id='action-modal.cancel'
                        defaultMessage='No, cancel'
                    />
                )
            }}
            confirm={{
                onConfirm: async () => {
                    if (!viewProps.selectedTrigger) return;
                    await Promise.all(
                        props.transactions.map(async (transaction) => {
                            await TransactionWorkflowClient.triggerTransactionState(transaction.account_id, transaction.id, {
                                trigger: viewProps.selectedTrigger!
                            });
                        })
                    );
                    if (props.onSubmitCallback) {
                        props.onSubmitCallback();
                    }
                    ToastUtil.success(
                        intl.formatMessage({
                            id: 'action-modal.change-transaction-state.success',
                            description: 'Toast shown when a transaction status is changed successfully',
                            defaultMessage: 'Changed transaction status successfully.'
                        })
                    );
                    viewProps.closeTopModal();
                },
                disabled: viewProps.isLoading || !viewProps.selectedTrigger,
                label: (
                    <FormattedMessage
                        id='action-modal.confirm-change-status'
                        defaultMessage='Yes, change status'
                    />
                )
            }}>
            <div className='text-brand-muted justify-start self-stretch text-base font-medium'>
                <FormattedMessage
                    id='action-modal.confirmation-message'
                    defaultMessage='Are you sure you want to change the status of all selected transactions? Based on your workflow settings, this action may trigger notifications to the senders and/or receivers.'
                />
            </div>
            <SelectInputV2
                hideLabel
                className='w-full'
                isLoading={viewProps.isLoading}
                onSelect={(v) => viewProps.setSelectedTrigger(v?.value as TransactionTriggerName | undefined)}
                options={viewProps.options}
            />
        </ActionModal>
    );
};
